import { Record, List } from 'immutable';
import { construct, fields } from '../helpers/LinkMapper';

const ReservationPassenger = new Record({
    statusCode: null,
    attributes: new List(),
});

ReservationPassenger.fromJSON = function(json) {
    return construct(ReservationPassenger, json, {
        statusCode: fields.string,
        attributes: fields.list,
    });
};

export default ReservationPassenger;



// WEBPACK FOOTER //
// ./src/records/ReservationRequestPassenger.js